import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    // Check if user has already given consent
    const hasConsent = localStorage.getItem('cookieConsent');
    if (!hasConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookieConsent', 'all');
    setIsVisible(false);
    // Enable all cookies
    enableAllCookies();
  };

  const handleAcceptEssential = () => {
    localStorage.setItem('cookieConsent', 'essential');
    setIsVisible(false);
    // Enable only essential cookies
    enableEssentialCookies();
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
    // Disable non-essential cookies
    disableNonEssentialCookies();
  };

  const enableAllCookies = () => {
    // Enable Google Analytics, marketing cookies, etc.
    console.log('All cookies enabled');
  };

  const enableEssentialCookies = () => {
    // Enable only essential cookies
    console.log('Essential cookies enabled');
  };

  const disableNonEssentialCookies = () => {
    // Disable analytics, marketing cookies
    console.log('Non-essential cookies disabled');
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent" role="dialog" aria-labelledby="cookie-title" aria-describedby="cookie-description">
      <div className="cookie-content">
        <div className="cookie-header">
          <h3 id="cookie-title">🍪 שימוש בעוגיות</h3>
        </div>
        
        <div className="cookie-body">
          <p id="cookie-description">
            אנו משתמשים בעוגיות כדי לשפר את חוויית הגלישה שלכם, לנתח תנועה באתר ולהציג תוכן מותאם אישית.
          </p>
          
          {showDetails && (
            <div className="cookie-details" aria-live="polite">
              <h4>סוגי עוגיות:</h4>
              <ul>
                <li>
                  <strong>עוגיות חיוניות:</strong> נדרשות לתפעול בסיסי של האתר (תמיד פעילות)
                </li>
                <li>
                  <strong>עוגיות ביצועים:</strong> עוזרות לנו להבין כיצד המבקרים משתמשים באתר
                </li>
                <li>
                  <strong>עוגיות שיווק:</strong> משמשות להצגת פרסומות רלוונטיות
                </li>
              </ul>
              <p>
                למידע נוסף, קראו את <Link to="/privacy-policy" aria-label="מדיניות הפרטיות שלנו">מדיניות הפרטיות</Link> שלנו.
              </p>
            </div>
          )}
        </div>
        
        <div className="cookie-actions">
          <button
            className="cookie-btn cookie-btn-details"
            onClick={() => setShowDetails(!showDetails)}
            aria-expanded={showDetails}
            aria-controls="cookie-details"
          >
            {showDetails ? 'הסתר פרטים' : 'הצג פרטים'}
          </button>
          
          <div className="cookie-buttons">
            <button
              className="cookie-btn cookie-btn-reject"
              onClick={handleReject}
              aria-label="דחה עוגיות לא חיוניות"
            >
              דחה
            </button>
            
            <button
              className="cookie-btn cookie-btn-essential"
              onClick={handleAcceptEssential}
              aria-label="קבל רק עוגיות חיוניות"
            >
              חיוניות בלבד
            </button>
            
            <button
              className="cookie-btn cookie-btn-accept"
              onClick={handleAcceptAll}
              aria-label="קבל את כל העוגיות"
            >
              קבל הכל
            </button>
          </div>
        </div>
      </div>
      
      <button
        className="cookie-close"
        onClick={handleReject}
        aria-label="סגור הודעת עוגיות"
        title="סגור"
      >
        ×
      </button>
    </div>
  );
};

export default CookieConsent;
